import { Route, Switch } from "react-router-dom";
import { UserContextProvider } from "./userContext";
import "font-awesome/css/font-awesome.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, Flip } from "react-toastify";
import Home from "./pages/home";
import Dashboard from "./pages/dashboard";
import NotFound from "./pages/notfound";

import "./App.scss";

function App() {
  return (
    <UserContextProvider>
      <div className="App">
        <ToastContainer
          position="top-center"
          autoClose={1500}
          newestOnTop
          transition={Flip}
        ></ToastContainer>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/dashboard" component={Dashboard} />
          <Route path="/not-found" component={NotFound} />
          <Route path="*" component={NotFound} />
        </Switch>
      </div>
    </UserContextProvider>
  );
}

export default App;
